




















import Vue, { PropOptions } from 'vue';

type OurTeam = Blok & {
  title: string;
  images: BlokFieldAsset[];
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<OurTeam>,
  },
});
